import { colors } from '@sweep-io/sweep-design';
import { Stack } from '@mui/material';
import { ReactNode } from 'react';

interface CardLayoutProps {
  borderColor?: string;
  nameJsx?: ReactNode;
  textJsx: ReactNode;
  bottomLeftJsx?: ReactNode;
  updateCardActionsJsx: ReactNode;
  readCardActionsJsx?: ReactNode;
  disabled?: boolean;
}

const EditableCardLayout = ({
  borderColor,
  nameJsx,
  textJsx,
  bottomLeftJsx,
  updateCardActionsJsx,
  readCardActionsJsx,
  disabled = false,
}: CardLayoutProps) => {
  return (
    <Stack
      sx={{
        padding: 2,
        background: disabled ? colors.grey[100] : colors.grey[100],
        borderRadius: '8px',
        border: `1px solid ${borderColor ?? 'transparent'}`,
        height: 'fit-content',
        opacity: disabled ? 0.6 : 1,
      }}
    >
      <Stack gap={2} flex={1}>
        <Stack gap={0.5} flex={1}>
          {(nameJsx || readCardActionsJsx) && (
            <Stack direction="row" gap={1} alignItems="center">
              <Stack flex={1} overflow="hidden">
                {nameJsx}
              </Stack>
              {readCardActionsJsx}
            </Stack>
          )}
          <Stack flex={1}>{textJsx}</Stack>
        </Stack>
        {(bottomLeftJsx || updateCardActionsJsx) && (
          <Stack direction="row" gap={1} justifyContent="space-between" alignItems="center">
            {bottomLeftJsx}
            {updateCardActionsJsx}
          </Stack>
        )}
      </Stack>
    </Stack>
  );
};

export default EditableCardLayout;
